import {
  Component,
  OnInit,
  Input,
  ViewChildren,
  QueryList,
  Optional,
} from '@angular/core';
import { FiltroControllerService } from 'src/app/services/filtro-controller.service';
import { CotacoesPDocs } from 'src/app/models/cotacoes.model';
import { CommonModule } from '@angular/common';
import { ModulosDeFormulario } from 'src/app/utils/formsModules';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { UsuariosComponent } from '../../sub-filtros/usuarios/usuarios.component';
import { StatusNegocioComponent } from '../../sub-filtros/status-negocio/status-negocio.component';
import { registerCloseOtherMenus } from '../../filtro-utils';
import { RamosComponent } from '../../sub-filtros/ramos/ramos.component';
import { Subscription } from 'rxjs';
import { FiltroCotacoesRamoService } from '../../filtros/cotacoes-ramo/filtro-cotacoes-ramo.service';
import { IntegracaoConstants } from 'src/app/constants/integracao';
import { PeriodoCotacoesComponent } from '../../sub-filtros/periodo-cotacoes/periodo-cotacoes.component';
import { OrigemCotacoesComponent } from '../../sub-filtros/origem-cotacoes/origem-cotacoes.component';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { heroClockMicro } from '@ng-icons/heroicons/micro';
import { heroChevronLeftMini } from '@ng-icons/heroicons/mini';
import {
  heroMapPinSolid,
  heroUserGroupSolid,
  heroCalculatorSolid,
} from '@ng-icons/heroicons/solid';
import { FiltroComponent } from '../../filtro.component';

@Component({
  selector: 'filtro-cotacoes-ramo',
  templateUrl: './cotacoes-ramo.component.html',
  styleUrls: ['../../filtro.component.scss'],
  providers: [
    provideIcons({
      heroClockMicro,
      heroChevronLeftMini,
      heroMapPinSolid,
      heroUserGroupSolid,
      heroCalculatorSolid,
    }),
  ],
  imports: [
    CommonModule,
    ModulosDeFormulario,
    MatTooltipModule,
    MatCheckboxModule,
    MatRadioModule,
    MatMenuModule,
    UsuariosComponent,
    StatusNegocioComponent,
    RamosComponent,
    PeriodoCotacoesComponent,
    OrigemCotacoesComponent,
    NgIcon,
  ],
})
export class CotacoesRamoComponent implements OnInit {
  @Input('listaUsuarios') listaUsuarios: any = {};
  @ViewChildren(MatMenuTrigger) allTriggers!: QueryList<MatMenuTrigger>;

  listaStatusNegocio = new CotacoesPDocs().getAllCotacaoStatus();

  filtroRamo: { ramo: string; subRamos: string[] }[] = [];
  filtroUsuario = [];
  filtroStatusNegocio = [];

  private tabSubscription!: Subscription;
  private clearSubscription!: Subscription;

  protected ramosTabs = IntegracaoConstants.ramosTabs;

  protected currentTab = this.ramosTabs[0];

  constructor(
    public filtroController: FiltroControllerService,
    private filtroCotacoesRamoService: FiltroCotacoesRamoService,
    @Optional() private filtroComp?: FiltroComponent
  ) {}

  ngOnInit() {
    this.inicializaFiltros();
    this.tabSubscription = this.filtroCotacoesRamoService.currentTab$.subscribe(
      (tab) => {
        this.currentTab = this.ramosTabs.find((x) => x.id == tab);
      }
    );

    this.clearSubscription = this.filtroCotacoesRamoService.clear$.subscribe(
      () => {
        this.clearFilter();
      }
    );
  }

  ngAfterViewInit() {
    registerCloseOtherMenus(this.allTriggers);
  }

  ngOnDestroy() {
    this.tabSubscription.unsubscribe();
    this.clearSubscription.unsubscribe();
  }

  buildString(clear = false) {
    this.filtroController.addFiltrosExtras(
      'cotacoes',
      this.filtroUsuario?.length > 0 || this.filtroStatusNegocio?.length > 0 || this.filtroRamo
        ? {
            listaRamo: this.filtroRamo,
            usuario: this.filtroUsuario,
            listaStatusNegocio: this.filtroStatusNegocio,
          }
        : 0
    );

    let rawValue = {
      usuario: this.filtroController.filtroCotacoes.usuario,
      listaStatusNegocio:
        this.filtroController.filtroCotacoes.listaStatusNegocio,
      listaRamo: this.filtroController.filtroCotacoes.listaRamo,
    };

    let filtros = { values: rawValue, clear: clear};

    this.filtroController.verificaFiltro();

    return filtros;
  }

  clearFilter() {
    this.filtroUsuario = [];
    this.limpaFiltroStatusNegocio();
    this.filtroRamo = [];
    this.filtroController.limparFiltro('cotacoes');
    this.filtroCotacoesRamoService.clearFilters();
    this.filtroController.verificaFiltro();
    this.buildString(true);
  }

  inicializaFiltros() {
    if (this.filtroController.filtroCotacoes) {
      this.filtroUsuario = this.filtroController.filtroCotacoes.usuario;
      this.filtroStatusNegocio =
        this.filtroController.filtroCotacoes.listaStatusNegocio;
      this.filtroRamo = this.filtroController.filtroCotacoes.listaRamo;
      this.verificaStatusNegocioSelecionado();
    }
  }

  atualizaFiltroStatusNegocio(payload: { negocio: number; newValue: boolean }) {
    const { negocio, newValue } = payload;

    if (!newValue) {
      let index = this.filtroStatusNegocio.findIndex((s) => s == negocio);
      this.filtroStatusNegocio.splice(index, 1);
      return;
    }

    for (let status of this.listaStatusNegocio) {
      if (status.value == negocio) {
        this.filtroStatusNegocio.push(negocio);
        break;
      }
    }

    this.filtroController.updateActiveFilters("status", this.filtroStatusNegocio.length);

    this.filtroComp?.sendFilter(false);
  }

  limpaFiltroStatusNegocio() {
    this.filtroStatusNegocio = [];
    for (let item of this.listaStatusNegocio) {
      item['ativo'] = false;
    }

    this.filtroComp?.sendFilter(false);
  }

  verificaStatusNegocioSelecionado() {
    for (let item of this.listaStatusNegocio) {
      for (let id of this.filtroStatusNegocio) {
        if (item.value === id) {
          item['ativo'] = true;

          this.filtroComp?.sendFilter(false);
        }
      }
    }
  }

  getRamosCount(){
    const ramoFilter = this.filtroController.getActiveFilter("ramos");

    return ramoFilter ?? 0;
  }

  getUsersCount(){
    const userFilter = this.filtroController.getActiveFilter("users");

    return userFilter ?? 0;
  }

  getStatusCount(){
    return this.filtroStatusNegocio.length ?? 0;
  }
}
